<template>
	<router-view></router-view>
</template>

<script>
	import {
		sessionStorage
	} from "@/utils/sessionStorage"
	import {
		computed,
		nextTick,
		onBeforeUnmount,
		reactive
	} from "vue-demi";
	import {
		useStore
	} from "vuex";
	export default {
		setup() {
			const store = useStore()
			const data = reactive({
				nickName: computed(() => {
					return store.state.user.userInfo.nickName;
				}),
			});

			return {
				data,
			};
		},
	}
</script>

<style>

</style>
